import { put, takeLatest } from 'redux-saga/effects';

import { consts as createChatConsts } from '../../ui/createchat';
import { actions as reqRelatedUsers } from '../reqRelatedUsers';

function* relatedUsersWorker(action) {
  if (action.payload) {
    yield put(reqRelatedUsers.send(action.payload));
  }
}

export default function* relatedUsersWorkerSaga() {
  yield takeLatest(createChatConsts.TOGGLE_VISIBILITY, relatedUsersWorker);
}



// WEBPACK FOOTER //
// ./src/redux/board/sagas/relatedUsers.js